import { GET_COMPANY_CUSTOMERS_BEGIN, GET_COMPANY_CUSTOMERS_FAILURE, GET_COMPANY_CUSTOMERS_SUCCESS, GET_COMPANY_CUSTOMER_BEGIN, GET_COMPANY_CUSTOMER_FAILURE, GET_COMPANY_CUSTOMER_SUCCESS, SET_COMPANY_CUSTOMER_QUERY } from '../constants/ActionTypes'


const initialState = {
    // Get Company Customers
    pagination: { page: 0, pageSize: 10 },
    filter: [],
    sorting: [],
    rowCount: 0,
    companyCustomers: null,
    isLoadingCompanyCustomers: false,
    hasErrorCompanyCustomers: null,

    // Get Company Customer
    companyCustomer: null,
    isLoadingCompanyCustomer: false,
    hasErrorCompanyCustomer: null,
}


/**
 * Reducer function for managing the state of the company customers.
 *
 * @author José Pedro Paludo
 * @param {Object} state - The current state of the company customers.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns {Object} - The new state of the company customers.
 */
const ReducerCompanyCustomer = (state = initialState, action) => {
    switch (action.type) {

        // Get Company Customers
        case GET_COMPANY_CUSTOMERS_BEGIN: {
            return {
                ...state,
                isLoadingCompanyCustomers: true
            }
        }

        case GET_COMPANY_CUSTOMERS_SUCCESS: {
            return {
                ...state,
                rowCount: action.payload?.count,
                companyCustomers: action.payload?.rows,
                isLoadingCompanyCustomers: false,
                hasErrorCompanyCustomers: null
            }
        }

        case GET_COMPANY_CUSTOMERS_FAILURE: {
            return {
                ...state,
                isLoadingCompanyCustomers: false,
                hasErrorCompanyCustomers: action.payload
            }
        }

        // Set Company Customers
        case SET_COMPANY_CUSTOMER_QUERY: {
            return {
                ...state,
                filter: action.payload.filter ?? state.filter,
                pagination: action.payload.pagination ?? state.pagination,
                sorting: action.payload.sorting ?? state.sorting
            }
        }

        // Get Company Customer
        case GET_COMPANY_CUSTOMER_BEGIN: {
            return {
                ...state,
                isLoadingCompanyCustomer: true
            }
        }

        case GET_COMPANY_CUSTOMER_SUCCESS: {
            return {
                ...state,
                companyCustomer: action.payload,
                isLoadingCompanyCustomer: false,
                hasErrorCompanyCustomer: null
            }
        }

        case GET_COMPANY_CUSTOMER_FAILURE: {
            return {
                ...state,
                companyCustomer: null,
                isLoadingCompanyCustomer: false,
                hasErrorCompanyCustomer: action.payload
            }
        }

        default: return state

    }
}

export default ReducerCompanyCustomer

